import { Star, Sparkles, CalendarClock, ShieldCheck } from 'lucide-react';
import { business } from '../../mock';

export default function About() {
  const stats = [
    { icon: Star, big: Number(business.googleRating).toFixed(1), small: 'Google rating' },
    { icon: Sparkles, big: `${business.googleReviewCount}+`, small: 'Five star reviews' },
    { icon: CalendarClock, big: '2022', small: 'Trusted local crew since' },
    { icon: ShieldCheck, big: 'Insured', small: 'Fully insured & checked' },
  ];

  return (
    <section id="about" className="py-24 cream-alt-bg">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div className="reveal">
            <p className="section-label mb-4">Ballarat</p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] mb-6">
              Reliable grounds care without the runaround.
            </h2>
            <p className="text-[#1E281C] text-lg leading-relaxed max-w-xl">
              Fast quotes, careful workmanship, and tidy finishing for homes, rentals,
              and commercial sites across Ballarat, from Alfredton, Lucas and Sebastopol
              to Wendouree, Delacombe and all the suburbs in between.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {stats.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.small}
                  className="reveal gold-top-card p-6"
                  style={{ transitionDelay: `${i * 90}ms` }}
                  data-testid={`trust-stat-${i}`}
                >
                  <Icon className="w-5 h-5 text-[#D98A00] mb-3" aria-hidden="true" />
                  <div className="font-extrabold text-2xl sm:text-3xl text-[#0A2E18] leading-none mb-1.5" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {s.big}
                  </div>
                  <div className="text-[#364234] text-sm leading-snug">{s.small}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
